module.exports = __webpack_public_path__ + "img/Charcuterie.9db87888.jpg";